import RegisterationForm from "./Fragments/RegisterationForm";
import AuthShell from "../pages/Layout/AuthShell";

const Registeration: React.FC<{ disableCustomTheme?: boolean }> = () => (
  <AuthShell>
    <RegisterationForm />
  </AuthShell>
);

export default Registeration;
